export const black = '#000';
export const white = '#fff';
export const offWhite = '#fafafa';
export const blueishWhite = '#FCFCFF';
export const gradientBlue = '#001129';
export const darkBlueA = '#002a44';
export const darkBlueB = '#003073';
export const darkBlueC = '#23344A';
export const paleBlue = '#2A61AD';
export const midBlue = '#39A7DB';
export const lightBlue = '#fbfbff';
export const footerTermsBlue = '#DAE1E6';
export const blueishGrey = '#777794';
export const lightBlueishGrey = '#d6d9e1';
export const darkmostGrey = '#777777';
export const darkestGrey = '#6A6A6A';
export const darkGrey = '#A6A8AB';
export const midGrey = '#e0e0e6';
export const lightGrey = '#f4f6f7';
export const yellow = '#FFBF00';
export const red = '#E44630';



// WEBPACK FOOTER //
// ./src/enums/colours.js